import { cn } from '@/app/utils'

type Props = {
  className?: string
  width?: number
  height?: number
}

export const ButtonSkeleton = ({ width, height, className }: Props) => (
  <button
    data-testid="skeleton-button-id"
    style={{
      maxWidth: width,
      width: width,
      maxHeight: height,
      height: height
    }}
    className={cn(
      'h-[30px] w-[230px] animate-pulse rounded-full bg-[rgba(16,24,32,.1)]',
      className
    )}
    disabled
  />
)
